<template>
  <v-app>
    <v-app-bar
      app
      color="indigo"
      dark
    >
      <div class="d-flex align-center">
        <v-img
          alt="karestan-javan"
          class="shrink mt-1 hidden-sm-and-down"
          contain
          min-width="200"
          src="@/assets/karestan-javan.png"
          width="200"
        />
      </div>

      <v-spacer></v-spacer>
      <template v-slot:extension>
        <v-tabs align-with-title>
          <v-tab to="/">Diff</v-tab>
          <v-tab to="/search">Search</v-tab>
          <v-tab to="/version">Version</v-tab>
        </v-tabs>
      </template>    
    </v-app-bar>

    <v-main>
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style>
.v-application--wrap, .v-main {
    height: 100vh !important;
}
</style>
